import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getAuthenticatedAxios } from "./use-authenticated-axios"
import type { DeleteApiKeyParams } from "src/internal-types"

export const useDeleteApiKey = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (params: DeleteApiKeyParams) => {
      const { workspace_id, ...deleteParams } = params
      const axios = getAuthenticatedAxios(workspace_id)
      const { data } = await axios.post(
        "/internal/api_keys/delete",
        deleteParams
      )
      return data
    },
    onSuccess: (_, params) => {
      qc.invalidateQueries({ queryKey: ["api_keys", params.workspace_id] })
    },
  })
}
